import type { he3MacorType } from "../data_conversion/he3";
import type { SetKeyType } from "../../define/request";
import type { Record, VK } from "../../define/define";

export enum MouseSetKeyType {
    Mouse = 0x01,
    Keyboard = 0x02,
    Media = 0x03,
    Extra = 0x05,
    Macro = 0x06
}

export enum MouseSetKeyTypeMouse {
    main = 0x01, // l\r\m\4\5
    wheel = 0x03,
    batter = 0x05,
    cursor = 0x06
}

// 0x01 -HW 切换情境设定档
// 0x02 -启动 OS 内程序
// 0x03 -停用
// 0x04- 缩放功能
// 0x05 无线电量
// 0x53- DPI + (Mouse Only)
// 0x54- DPI – (Mouse Only)
// 0x55- DPI Loop + (Mouse Only)
// 0x56- DPI Loop – (Mouse Only)
// export enum MouseSetKeyTypeExtra {
//     switchScenes = 0x01,
//     startTheProgramInOS = 0X02,
//     stopUsing = 0x03,
//     scaleFunction = 0x04,
//     radioVolume = 0x05,
//     DPI = 0x53,
//     DPI_Increase = 0x54,
//     DPI_Loop = 0x55,
//     DPI_Loop_Decrease = 0x56,
// }

export interface postMapKey {
    SetType: SetKeyType,
    Modifier: VK[],
    Key: VK,
    MacroIndex: number,
    MacroType: he3MacorType,
    MacroTimes: number,
}

export enum deviceType {
    mouse = 0x01,
    keyboard
}



export interface MouseConfig {
    LockAltTab: boolean;
    LockAltF4: boolean;
    LockWindows: boolean;
    ReportRate: number;
    DpiIndex: number;
    DpiCount: number;
    DpiData: Dpidatum[];
}

interface Dpidatum {
    Value: number;
    Rgb: number[];
    Enable: boolean;
}



export interface MouseDpiData {
    Dpi: number,
    Color: number[]
}

export enum DpiAction {
    Add = 0,
    Del = 1,
    Mod = 2
}

export interface PostSetDpiData {
    Action: DpiAction,
    DpiIndex: number,
    DpiData: MouseDpiData,
    Rate: number
}

export interface PostSwitchDpi {
    DpiIndex: number
}

export interface SetMacro {
    CycleType: number;
    CycleTimes: number;
    Records: Record[]
}
